import AppHeader from "@/components/AppHeader";

export default {
  name: "master-approval-edit",
  components: {
    AppHeader
  },
  created() {
    this.getCompanyShow();
    this.getDepartmentShow();
    if (this.$route.params.approval_id != 0) {
      this.getApproval();
    } else {
      this.getApprovalEnd = true;
    }
    this.getCompanyIndex();
  },
  data() {
    return {
      companyName: "",
      departmentName: "",
      companyAll: "",
      departmentAll: "",
      userAll: "",
      getCompanyEnd: false,
      getDepartmentEnd: false,
      getApprovalEnd: false,
      getCompanyIndexEnd: false,
      getDepartmentIndexEnd: false,
      getUserGeneralEnd: false,
      approvals: [],
      isModalOn: false,
      savingFlag: false
    };
  },
  computed: {
    attendanceType() {
      return this.$t(`attendanceTypes.${this.$route.params.approval_type}`);
    }
  },
  methods: {
    async getCompanyShow() {
      let data = {};
      let res = await this.$store
        .dispatch("SHOW_COMPANY", {
          id: this.$route.params.company_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.companyName = res.company.name;
      this.getCompanyEnd = true;
    },
    async getDepartmentShow() {
      let data = {};
      let res = await this.$store
        .dispatch("SHOW_DEPARTMENT", {
          id: this.$route.params.department_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.departmentName = res.department.name;
      this.getDepartmentEnd = true;
    },
    async getApproval() {
      let data = {
        company_id: this.$route.params.company_id,
        department_id: this.$route.params.department_id,
        approval_type: this.$route.params.approval_type
      };
      let res = await this.$store
        .dispatch("GET_APPROVAL_BY_DEPARTMENT_TYPE", {
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.addApproval();
      for (let i = 0; i < res.approvals.length; i++) {
        this.approvals[i].company_id = res.approvals[i].company_id;
        this.approvals[i].department_id = res.approvals[i].department_id;
        this.approvals[i].department_name = res.approvals[i].department_name;
        this.approvals[i].user_id = res.approvals[i].user_id;
        this.approvals[i].user_name =
          res.approvals[i].last_name + " " + res.approvals[i].first_name;
        this.approvals[i].approval_type = this.$route.params.approval_type;
        this.addApproval();
      }
      this.removeApproval(this.approvals.length - 1);
      this.getApprovalEnd = true;
    },
    async getCompanyIndex() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", {
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.companyAll = res.companies;
      this.getCompanyIndexEnd = true;
    },
    async getDepartmentIndex(index) {
      this.approvals[index].department_id = "";
      this.approvals[index].department_name = "";
      this.approvals[index].user_id = "";
      this.approvals[index].user_name = "";
      let data = {
        company_id: this.approvals[index].company_id
      };
      let res = await this.$store
        .dispatch("GET_DEPARTMENT", {
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.departmentAll = res.departments;
      this.getDepartmentIndexEnd = true;
    },
    async getUserGeneral(index) {
      let findDepartment = this.departmentAll.find(
        department => department.id == this.approvals[index].department_id
      );
      this.approvals[index].department_name = findDepartment.name;
      this.approvals[index].user_id = "";
      this.approvals[index].user_name = "";
      let data = {
        company_id: this.approvals[index].company_id,
        department_id: this.approvals[index].department_id
      };
      let res = await this.$store
        .dispatch("GENERAL_GET_USER", {
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.userAll = res.users;
      this.getUserGeneralEnd = true;
    },
    async editApproval() {
      if (this.savingFlag) return;
      this.savingFlag = true;
      let data = {
        approvals: this.approvals,
        company_id: this.$route.params.company_id,
        department_id: this.$route.params.department_id,
        approval_type: this.$route.params.approval_type,
        approval_id: this.$route.params.approval_id
      };
      let res = await this.$store
        .dispatch("CREATE_OR_EDIT_APPROVAL", {
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
      } else {
        this.goApprovalDetail();
      }
    },
    changeUser(index) {
      let findUser = this.userAll.find(
        user => user.id == this.approvals[index].user_id
      );
      this.approvals[index].user_name =
        findUser.last_name + " " + findUser.first_name;
    },
    addApproval() {
      let approval = {
        company_id: "",
        department_id: "",
        department_name: "",
        user_id: "",
        user_name: "",
        approval_type: this.$route.params.approval_type
      };
      this.approvals.push(approval);
    },
    addApprovalModal() {
      this.isModalOn = true;
      this.$bvModal.show("modal-work");
      let approval = {
        company_id: "",
        department_id: "",
        department_name: "",
        user_id: "",
        user_name: "",
        approval_type: this.$route.params.approval_type
      };
      this.approvals.push(approval);
    },
    removeApproval(index) {
      this.approvals.splice(index, 1);
    },
    async removeApprovalModal(index) {
      await this.$bvModal.hide("modal-work");
      this.approvals.splice(index, 1);
      this.isModalOn = false;
    },
    canAdd(index) {
      if (
        this.approvals[index].company_id &&
        this.approvals[index].department_id &&
        this.approvals[index].user_id
      ) {
        return false;
      } else {
        return true;
      }
    },
    goApprovalDetail() {
      this.$router.push({
        path: `/master_approval/${this.$route.params.company_id}/${this.$route.params.department_id}/${this.$route.params.approval_type}`
      });
    }
  }
};
